<template>
    <AppLayout>
        <!-- breadcrumb -->
        <div class="relative">
            <nav
                class="my-6 text-sm font-semibold"
                aria-label="Breadcrumb"
            >
                <ol class="inline-flex p-0 list-none">
                    <li class="flex items-center text-blue-500">
                        <inertia-link
                            :href="route('landing')"
                            class="text-gray-600"
                        >
                            {{ $t('LBL_HOME') }}
                        </inertia-link>
                        <svg
                            fill="#34D399"
                            class="w-3 h-3 mx-3"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path
                                d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                            />
                        </svg>
                    </li>
                    <li class="flex items-center">
                        <inertia-link
                            :href="route('invoice.dispatch')"
                            class="text-gray-600"
                        >
                            {{ $tc('LBL_INVOICE', 1) }}
                        </inertia-link>
                        <svg
                            fill="#34D399"
                            class="w-3 h-3 mx-3"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path
                                d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                            />
                        </svg>
                    </li>
                    <li class="flex items-center">
                        <a
                            href="#"
                            class="text-gray-600"
                            >Dispatch Invoice</a
                        >
                    </li>
                </ol>
            </nav>

            <!-- Invoice Template -->
            <div
                id="print-invoice"
                class="mb-10"
            >
                <InvoiceTemplate :bill="bill" />
            </div>

            <!-- Dispatch Form -->
            <div class="max-w-3xl mx-auto bg-white rounded-lg shadow-md px-6 py-6 space-y-4 border border-gray-200">
                <h2 class="text-lg font-semibold text-gray-800">Dispatch Details</h2>

                <t-input
                    v-model="shippedPayload.driverName"
                    placeholder="Driver Name"
                    class="w-full"
                />
                <t-input
                    v-model="shippedPayload.truckNumber"
                    placeholder="Truck Number"
                    class="w-full"
                />

                <t-button
                    type="button"
                    variant="success"
                    class="w-full justify-center py-2"
                    @click="changeStatusToShipped()"
                >
                    <div class="flex items-center justify-center gap-2 font-semibold">
                        <span>Dispatch</span>
                        <PrintIcon class="w-5" />
                    </div>
                </t-button>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import axios from 'axios';
    import InvoiceTemplate from '@/Components/Templates/InvoiceTemplate.vue';
    import AppLayout from '@/Layouts/AppLayout.vue';
    import PrintIcon from '@/Components/Icons/PrintIcon.vue';

    export default {
        name: 'DispatchInvoice',

        components: {
            AppLayout,
            InvoiceTemplate,
            PrintIcon,
        },

        props: {
            bill: { type: Object, required: true },
        },

        data() {
            return {
                // driver: '',
                // truckNo: '',

                shippedPayload: {
                    driverName: '',
                    truckNumber: '',
                },
            };
        },

        methods: {
            async printInvoice() {
                await this.$htmlToPaper('print-invoice');
            },

            async changeStatusToShipped() {
                await this.printInvoice();
                axios
                    .get(route('bill.shipped', this.bill.id), {
                        headers: {
                            Accept: 'application/json',
                        },
                        params: this.shippedPayload,
                    })
                    .then(() => {
                        this.goto('bills.packed');
                    });
            },
        },
    };
</script>

<style></style>
